import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { CalAngularService } from "@cvx/cal-angular";
import { jwtDecode } from "jwt-decode";
import { from, lastValueFrom, Observable, switchMap } from "rxjs";
import { environment } from "../../environments";
import { AppConfig } from "./app-config.service";
import { AuthService, Role } from "./auth.service";

export interface JwtPayload {
  roles?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
  private appConfig = new AppConfig();
  private authService = inject(AuthService);

  private httpHeaders: HttpHeaders = new HttpHeaders()
    .set('Accept', ['application/json', 'image/svg+xml'])
    .set('Content-Type', ['application/json', 'image/svg+xml'])
    .set('Access-Control-Allow-Origin', environment.apiUrl)
    .set('Access-Control-Allow-Methods', 'GET')
    .set('Access-Control-Allow-Headers', 'Content-Type')
    .set('Access-Control-Max-Age', '86400');

  private httpHeadersW: HttpHeaders = new HttpHeaders()
    .set('Access-Control-Allow-Origin', environment.apiUrl)
    .set('Access-Control-Allow-Methods', 'GET')
    .set('Access-Control-Allow-Headers', 'Content-Type')
    .set('Access-Control-Max-Age', '86400');

  constructor(private cal: CalAngularService) {
    this.appConfig.load().then();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.url.includes('powerautomate/automations/direct')) {
      return next.handle(req); // skip adding token for RIPT this is TEMPORARY until fixed in backend
    }

    const isFormData = req.url.includes('RiskEvaluation') //|| req.method === 'POST' && req.url.includes('NotesAndAttachments');

    const comboHeaders = this.addHeaders(isFormData, req.headers);
    return from(this.updateAuthorizationHeader(comboHeaders)).pipe(
      switchMap(chdrs => {
        const cloned = req.clone({
          headers: chdrs
        });
        return next.handle(cloned);
      })
    );
  }

  private async updateAuthorizationHeader(headers: HttpHeaders): Promise<HttpHeaders> {
    const scope = environment.scopeUrl;
    const token = await lastValueFrom(this.cal.getAADToken([scope], false)) as string;

    this.authService.setToken(token);
    this.saveRoles(token);

    const bearerToken = `Bearer ${token}`;
    if (headers.get('Authorization') !== bearerToken) {
      return headers.set('Authorization', bearerToken);
    }

    return headers;
  }


  private addHeaders(isFormData: boolean, headers?: HttpHeaders): HttpHeaders {
    const isFormType = headers?.get('Content-Type')?.toLowerCase().includes('form-data');
    
    const comboHeaders = isFormData || isFormType ? this.httpHeadersW : this.httpHeaders;

    if (headers) {
      headers.keys().forEach((key) => {
        let header = headers.get(key);
        if (header)
          comboHeaders.append(key, header);
      });
    }

    return comboHeaders;
  }

  private saveRoles(token: string) {
    const decoded = jwtDecode<JwtPayload>(token);
    let roles: string[] = [];

    if (Array.isArray(decoded.roles)) {
      roles = decoded.roles;
      this.authService.setRoles(roles as Role[]);
    }
  }
}

